<template>
    <div class="avatar-wrapper">
        <cube-upload
            ref="upload"
            :max="1"
            v-model="files"
            @files-added="handleFilesAdd"
            @file-success="handleFileSuccess"
            @file-error="handleFileError"
            @file-submitted="handleFileSubmitted"
            :action="opts"
            :simultaneous-uploads="1">
            <cube-upload-file v-for="(file, i) in files" :file="file" :key="i"></cube-upload-file>
            <cube-upload-btn :multiple="false" icon="img-icon icon-password">
              <div class="upload-btn" :class="{avatarNotLoading: !loading}">
                <van-loading :class="{avatarNotLoading: !loading}" type="spinner" size="40px" color="#fff"/>
              </div>
            </cube-upload-btn>
        </cube-upload>
    </div>
</template>

<script>
import compress from '@/utils/compress-image.js'
export default {
  name: 'avatar',
  props: {
    action: {
      type: Object,
      default () {
        return {}
      }
    },
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler () {
        if (this.value !== this.files) this.files = this.value
      }
    },
    options: {
      immediate: true,
      deep: true,
      handler () {
        this.opts = Object.assign({}, this.defaultAction, this.action)
      }
    },
    files: {
      deep: true,
      handler () {
        this.$emit('input', this.files)
      }
    }
  },
  data () {
    return {
      files: [],
      opts: {},
      defaultAction: {
        target: '//jsonplaceholder.typicode.com/photos/'
        // prop: 'base64Value'
      },
      loading: false
    }
  },
  methods: {
    handleFilesAdd () {
      const file = this.files[0]
      file && this.$refs.upload.removeFile(file)
    },
    handleFileSuccess (data) {
      let resp = data.response
      const file = this.files[0]
      this.$set(file, 'id', resp.data ? resp.data.id : '')
      this.$emit('finished', resp)
      this.loading = false
    },
    handleFileError (file) {
      const resp = file.response
      this.createToast(resp).show()
      this.$emit('error', resp)
      this.loading = false
    },
    handleFileSubmitted (file) {
      // file.base64Value = file.file.base64
      this.$emit('upload-begin')
      this.loading = true
    },
    processFile(file, next) { // 10k以上还是原来的方式上传好
      compress(file, {
        compress: {
          width: 1600,
          height: 1600,
          quality: 1
        }
      }, next)
    }
  }
}
</script>

<style lang="scss">
.avatar-wrapper {
  text-align: center;
  line-height: 120px;
    .cube-upload {
        width: 136px;
        height: 136px;
        border: 4px solid #409bff;
        border-radius: 8px;
    }
    .cube-upload-file {
        width: 100%;
        height: 100%;
    }
    .cube-upload-file-def {
        width: 100%;
        height: 100%;
    }
    .cube-upload-file-state { // 隐藏掉状态
        display: none;
    }
    .cube-upload-btn {
        width: 100%;
        height: 100%;
        position: absolute;
        overflow: hidden;
        top: 0;
        left: 0;
    }
    .cube-upload-btn-def {
        font-size: 0;
        width: 100%;
        height: 100%;
        display: none;
        i {
            display: none;
        }
    }
    .cube-upload-file-def {
        .cubeic-wrong {
            display: none;
        }
    }
    .upload-btn {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(7, 17, 27, 0.4);
    }
    .avatarNotLoading {
      display: none
    }
}
</style>



// WEBPACK FOOTER //
// src/components/avatar/index.vue